import { configure } from "@testing-library/react";
import axios from 'axios';

let conf = {

    uri_backend: process.env.REACT_APP_URI_BACKEND,
    uri_frontend: process.env.REACT_APP_URI_FRONTEND,
    uri_sso: process.env.REACT_APP_URI_SSO,
    uri_s3: 'https://s3.schoolmedia.id'
}

// Global axios interceptor: capture refreshed JWT tokens from backend
axios.interceptors.response.use(
    (response) => {
        const authHeader = response.headers['authorization'];
        if (authHeader && authHeader.startsWith('Bearer ')) {
            const newToken = authHeader.substring(7);
            if (newToken && newToken !== localStorage.getItem('token')) {
                localStorage.setItem('token', newToken);
            }
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default conf;
